import React, { useState, useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { Modal } from "react-bootstrap";

import styles from "./Tooltip.module.sass";
import mediaQuery from "../../../utils/mediaQuery";
import Button from "../Button/Button";

const tooltip = (props) => {
  const [desktop, setDesktop] = useState(
    mediaQuery.watchIfDesktop((e) => setDesktop(e.matches))
  );
  const [showModal, setShowModal] = useState(false);

  useEffect(() => mediaQuery.unsubscribe, []);
  return desktop ? (
    <OverlayTrigger
      className={styles.tooltip}
      trigger="hover"
      key="right"
      placement="right"
      flip={true}
      popperConfig={{
        modifiers: {
          preventOverflow: {
            enabled: true,
            behavior: ["right", "bottom", "left", "top"],
            boundariesElement: "viewport",
          },
        },
      }}
      overlay={
        <Popover
          id={`popover-positioned-right`}
          className={styles.tooltipContent}
        >
          {props.children}
        </Popover>
      }
    >
      <span className={[props.className, styles.iconTooltip].join(" ")}>
        <span>Saiba mais</span>
      </span>
    </OverlayTrigger>
  ) : (
    <>
      <div className={[props.className, styles.iconTooltip].join(" ")}>
        <span onClick={() => setShowModal(true)}>Saiba mais</span>
      </div>
      <Modal
        centered
        dialogClassName={styles.modalDialog}
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className={styles.modalMsg}>
            {props.title}
            <span className={styles.additionalInfo}> {props.children}</span>
          </div>
          <div className={styles.actions}>
            <Button onClick={() => setShowModal(false)}>Fechar</Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default tooltip;
